/* tslint:disable */
/* eslint-disable */
/**
 * NinjaAPI
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface MetricFlag
 */
export interface MetricFlag {
    /**
     * 
     * @type {string}
     * @memberof MetricFlag
     */
    label: string;
}

/**
 * Check if a given object implements the MetricFlag interface.
 */
export function instanceOfMetricFlag(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "label" in value;

    return isInstance;
}

export function MetricFlagFromJSON(json: any): MetricFlag {
    return MetricFlagFromJSONTyped(json, false);
}

export function MetricFlagFromJSONTyped(json: any, ignoreDiscriminator: boolean): MetricFlag {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'label': json['label'],
    };
}

export function MetricFlagToJSON(value?: MetricFlag | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'label': value.label,
    };
}

